<!-- <header class="player-header">
  <div class="player-header--logo">
    <img class="player-header--logo--image" src="assets/images/logo_icon.png">
    <h1 class="logo-font player-header--logo--title">HARAPPA</h1>
  </div>
</header> -->

<div class="d-flex align-items-center justify-content-center benchmark--loader pageloader--message">
  <div>
    <img class="mx-auto loader-gif" src="assets/images/upgradRed/upgradLoader.gif">
    <div>Submitting your responses</div>
  </div>
</div>